module.exports = __webpack_public_path__ + "img/erweima.9456e7d3.png";